export const GetOrdersFromView = (api, ordersFilterCriteria, cancelToken, pageNo) => {
  var filters = {
    CustId: ordersFilterCriteria.custId,
    DateFrom: ordersFilterCriteria.dateFrom,
    DateTo: ordersFilterCriteria.dateTo,
    SelectedSeller: ordersFilterCriteria.selectedSeller,
    SelectedAddress: ordersFilterCriteria.selectedAddress,
    OrderBy: ordersFilterCriteria.orderBy,
    IsArchive: ordersFilterCriteria.isArchive,
    Status: ordersFilterCriteria.status,
  }
  return api.post(`/api/v1/Orders/GetOrders?pageNumber=${pageNo}`, filters, { cancelToken: cancelToken })
}

export const GetOrderFromView = (api, orderId, custId) => {
  return api.get(`/api/v1/Orders/getOrder?orderId=${orderId}&custId=${custId}`)
}

export const GetWzDocFromView = (api, wzFilterCriteria, cancelToken, pageNo) => {
  var filters = {
    CustId: wzFilterCriteria.custId,
    DateFrom: wzFilterCriteria.dateFrom,
    DateTo: wzFilterCriteria.dateTo,
    OrderBy: wzFilterCriteria.orderBy,
    SelectedStatus: wzFilterCriteria.selectedStatus,
    SelectedSeller: wzFilterCriteria.selectedSeller,
    SelectedAddress: wzFilterCriteria.selectedAddress,
    IsArchive: wzFilterCriteria.isArchive,
  }
  return api.post(`/api/v1/Orders/GetWzDoc?pageNumber=${pageNo}`, filters, { cancelToken: cancelToken })
}

export const ChangeCustOrderNumber = (api, docNum, custDocNum, custId, siteId) => {
  let tmpCustNumber = custDocNum ? custDocNum : "";
  return api.get(`/api/v1/Orders/ChangeCustOrderNumber?docNum=${docNum}&custDocNum=${tmpCustNumber}&custId=${custId}&siteId=${siteId}`)
}

export const GetOrderItems = (api, orderNumber) => {
  return api.get(`/api/v1/Orders/GetOrderItems?orderNumber=${orderNumber}`)
}

export const GetBankTransferData = (api, siteId) => {
  return api.get(`/api/v1/Orders/GetBankTransferData?siteId=${siteId}`)
}

export const GetOrderFiltersData = (api, filters, cancelToken) => {
  var data = {
    CustId: filters.custId,
    DateFrom: filters.dateFrom,
    DateTo: filters.dateTo,
    SelectedSeller: filters.selectedSeller,
    SelectedAddress: filters.selectedAddress,
    SelectedStatus: filters.selectedStatus,
    OrderBy: filters.orderBy,
    IsArchive: filters.isArchive,
  }
  return api.post(`/api/v1/Orders/GetOrderFiltersData`, data, { cancelToken: cancelToken })
}

export const GetWzDocFiltersData = (api, filters) => {
  var data = {
    CustId: filters.custId,
    DateFrom: filters.dateFrom,
    DateTo: filters.dateTo,
    SelectedSeller: filters.selectedSeller,
    SelectedAddress: filters.selectedAddress,
    OrderBy: filters.orderBy,
    SelectedStatus: filters.selectedStatus,
    IsArchive: filters.isArchive,
  }
  return api.post(`/api/v1/Orders/GetWzDocFiltersData`, data)
}